/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Detail_No_Slots_CtaInputs */

const en_job_detail_no_slots_cta = /** @type {(inputs: Job_Detail_No_Slots_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add time slots`)
};

const de_job_detail_no_slots_cta = /** @type {(inputs: Job_Detail_No_Slots_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termine hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add time slots" |
*
* @param {Job_Detail_No_Slots_CtaInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const job_detail_no_slots_cta = /** @type {((inputs?: Job_Detail_No_Slots_CtaInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Detail_No_Slots_CtaInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_detail_no_slots_cta(inputs)
	return en_job_detail_no_slots_cta(inputs)
});